import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

//
import Api from "./api";
import Provider from "../../../context/auth/AuthProvider";
import Consts from "../../../utils/consts";

//
const initialState = {
  user: null,
  isAuth: false,
  loading: false,
  authLoading: false,
};

export default function Auth({ children }) {
  // router
  const navigate = useNavigate();

  // state
  const [auth, setAuth] = useState({
    ...initialState,
  });

  //   lifecycle
  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   methods
  function changeUser(user) {
    setAuth((p) => ({ ...p, user }));
  }

  function changeInitAuthState() {
    setAuth({ ...initialState });
  }

  function changeIsAuth(isAuth) {
    setAuth((p) => ({ ...p, isAuth }));
  }

  function changeLoading(loading) {
    setAuth((p) => ({ ...p, loading }));
  }

  function changeAuthLoading(loading) {
    setAuth((p) => ({ ...p, loading }));
  }

  function seperateRes(data) {
    const { token, ...user } = data;
    window.localStorage.setItem(Consts.APP_TOKEN, JSON.stringify(token));
    changeIsAuth(true);
    changeUser(user);
    navigate("/");
  }

  function errorHandler(error, err = "") {
    changeInitAuthState();
    if (!err) return;
    toast.error(err);
  }

  //   api calls
  async function checkAuth() {
    changeLoading(true);
    try {
      const { data } = await Api.checkAuth();
      changeIsAuth(true);
      changeUser({ ...data });
    } catch (error) {
      errorHandler(error);
    } finally {
      changeLoading(false);
    }
  }

  async function register(body) {
    changeAuthLoading(true);
    try {
      const { data } = await Api.register(body);
      seperateRes(data);
      navigate("/");
    } catch (error) {
      errorHandler(error, "Error in registration !");
    } finally {
      changeAuthLoading(false);
    }
  }

  async function login(body) {
    changeAuthLoading(true);
    try {
      const { data } = await Api.login(body);
      seperateRes(data);
    } catch (error) {
      errorHandler(error, "Error in loginning !");
    } finally {
      changeAuthLoading(false);
    }
  }

  function logout() {
    window.localStorage.removeItem(Consts.APP_TOKEN);
    changeInitAuthState();
  }

  return (
    <Provider
      value={{
        state: auth,
        fn: { register, login, logout },
      }}
    >
      {children}
    </Provider>
  );
}
